import React, { useEffect,useState } from 'react'
import { UserAnalyticsWrapper } from './UserAnalyticsModal.style'
import { message,Modal } from 'antd';
import SecuredServices from 'api/securedServices';
import {ExclamationCircleFilled} from '@ant-design/icons';


const { confirm } = Modal;
export default function UserAnalyticsModal({userid}) {
    
    const [analytics,setAnalytics] = useState({});
    function convertNestedValuesToInt(obj) {
        const result = {};
      
        for (const [outerKey, innerObj] of Object.entries(obj)) {
          result[outerKey] = {};
      
          for (const [key, value] of Object.entries(innerObj)) {
            result[outerKey][key] = parseInt(value, 10);
          }
        }
      
        return result;
      }
    useEffect(()=>{
        // console.log(data);
        // let userid = data.userid;
        SecuredServices.getUserAnalytics(userid).then((res)=>{
            console.log(res.data);
            if(res.data.status==1){
                let tempData = res.data.data;
                tempData = convertNestedValuesToInt(tempData);
               
                console.log(tempData);
                setAnalytics(tempData);
            }
            else{
                message.error(res.data.message);
            }
        }).catch((err)=>{
            console.log(err);
            message.error(err.message);
        })
    },[userid])

  return (
    <UserAnalyticsWrapper>
          <h2 className='text-center dark-blue'>Analytics</h2>
        <div className='outerTableDiv'>
            {/* <h3 className='text-center' style={{color:"green",fontSize:"17px",fontWeight:"bold"}}>
                Total Earnings (Pending + Paid) : ₹{analytics.totalAmount}
            </h3> */}
            <div className='tableCus'>
                <div className='headings'>
                    <p>Type</p>
                    <p>Submissions (Total)</p>
                    <p>Paid</p>
                    <p>Pending</p>
                </div>
                {
                    analytics?.uploads &&   <div className='content'>
                    <p>Questions Uploaded</p>
        
                    <div>
                        <p> Descriptive :{analytics?.uploads?.descriptive_uploads}</p>
                        <p> Mcq :{analytics?.uploads?.mcq_uploads}</p>
                        </div>
                        <p>NOT PAYABLE</p>
                        <p>0</p>
                    {/* <p>₹{analytics?.iqCreation?.amount_for_iq_with_image}</p> */}
                </div>
                }
                {
                    analytics?.iqCreations &&   <div className='content'>
                    <p>IQ creations with image</p>
                    <p>{analytics?.iqCreations?.count_with_image??0}</p>
                    <p>{analytics?.iqCreations?.count_paid_with_image ??0}</p>
                    <p>{analytics?.iqCreations?.count_with_image-analytics?.iqCreations?.count_paid_with_image ??0}</p>
                </div>
                }
                {
                      analytics?.iqCreations &&  <div className='content'>
                      <p>IQ creations without image</p>
                      <p>{analytics?.iqCreations?.count_without_image}</p>
                      <p>{analytics?.iqCreations?.count_paid_without_image}</p>
                      <p>{analytics?.iqCreations?.count_without_image-analytics?.iqCreations?.count_paid_without_image}</p>
                  </div>
                }
                {
                      analytics?.programCreations &&   <div className='content'>
                      <p>Program creations with image</p>
                      <p>{analytics?.programCreations?.program_count_with_image}</p>
                      <p>{analytics?.programCreations?.program_count_paid_with_image}</p>
                      <p>{analytics?.programCreations?.program_count_with_image-analytics?.programCreations?.program_count_paid_with_image}</p>

                  </div>
                }
                {
                      analytics?.programCreations &&   <div className='content'>
                      <p>Program creations without image</p>
                      <p>{analytics?.programCreations?.program_count_without_image}</p>
                      <p>{analytics?.programCreations?.program_count_paid_without_image}</p>
                      <p>{analytics?.programCreations?.program_count_without_image-analytics?.programCreations?.program_count_paid_without_image}</p>
                  </div> 
                }
                {
                    analytics?.iqVerifications &&   <div className='content'>
                    <p>IQ verifications</p>
                    <p>{analytics?.iqVerifications?.total_verifications}</p>
                    <p>{analytics?.iqVerifications?.verifications_paid}</p>
                    <p>{analytics?.iqVerifications?.total_verifications-analytics?.iqVerifications?.verifications_paid}</p>

                </div>
                }
               
                {/* <div className='content'>
                    <p>Program verifications</p>
                    <p>{analytics?.missionVerification?.count}</p>
                    <p>₹{analytics?.missionVerification?.amount}</p>
                </div> */}
                {/* <div className='footer'>
                    <p>Total</p>
                    <p>{analytics?.totalSubmissions}</p>
                    <p>{analytics?.totalAmount}</p>
                </div> */}
            </div>
        </div>

        {/* <div className='settleEarningsDiv'>
            <bold>Note: Please settle the earnings once the payment is done.</bold>
            <button className='settleEarnings' onClick={handleClickOnSettleEarnings}>Settle Earnings</button>
        </div> */}
    </UserAnalyticsWrapper>
  )
}
